// Shared dropdown options for data entry consistency across the CRM

export const SOURCES = [
  { value: "website", label: "Website" },
  { value: "99acres", label: "99acres" },
  { value: "magicbricks", label: "MagicBricks" },
  { value: "housing", label: "Housing.com" },
  { value: "referral", label: "Referral" },
  { value: "walk_in", label: "Walk-in" },
  { value: "ivr_incoming", label: "IVR / Incoming Call" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "facebook", label: "Facebook" },
  { value: "google", label: "Google Ads" },
  { value: "instagram", label: "Instagram" },
  { value: "linkedin", label: "LinkedIn" },
  { value: "channel_partner", label: "Channel Partner" },
  { value: "newspaper", label: "Newspaper" },
  { value: "hoarding", label: "Hoarding/OOH" },
  { value: "sms", label: "SMS Campaign" },
  { value: "events", label: "Events" },
  { value: "cold_call", label: "Cold Call" },
  { value: "email", label: "Email" },
  { value: "mhm_lite", label: "MhM Lite" },
  { value: "other", label: "Other" },
];

export const CONFIGURATIONS = [
  { value: "Studio", label: "Studio" },
  { value: "1RK", label: "1 RK" },
  { value: "1BHK", label: "1 BHK" },
  { value: "1.5BHK", label: "1.5 BHK" },
  { value: "2BHK", label: "2 BHK" },
  { value: "2.5BHK", label: "2.5 BHK" },
  { value: "3BHK", label: "3 BHK" },
  { value: "3.5BHK", label: "3.5 BHK" },
  { value: "4BHK", label: "4 BHK" },
  { value: "4BHK+", label: "4 BHK+" },
  { value: "Penthouse", label: "Penthouse" },
  { value: "Villa", label: "Villa" },
  { value: "Duplex", label: "Duplex" },
  { value: "Plot", label: "Plot" },
];

export const BUDGET_PRESETS = [
  { value: 2000000, label: "₹20 Lakh" },
  { value: 3000000, label: "₹30 Lakh" },
  { value: 4000000, label: "₹40 Lakh" },
  { value: 5000000, label: "₹50 Lakh" },
  { value: 6000000, label: "₹60 Lakh" },
  { value: 7500000, label: "₹75 Lakh" },
  { value: 10000000, label: "₹1 Crore" },
  { value: 12500000, label: "₹1.25 Crore" },
  { value: 15000000, label: "₹1.5 Crore" },
  { value: 20000000, label: "₹2 Crore" },
  { value: 25000000, label: "₹2.5 Crore" },
  { value: 30000000, label: "₹3 Crore" },
  { value: 50000000, label: "₹5 Crore" },
  { value: 75000000, label: "₹7.5 Crore" },
  { value: 100000000, label: "₹10 Crore" },
];

export const LOCALITIES = [
  "Andheri", "Bandra", "Borivali", "Chembur", "Dadar",
  "Goregaon", "Juhu", "Kandivali", "Khar", "Kurla",
  "Malad", "Mulund", "Powai", "Thane", "Vikhroli",
  "Worli", "Lower Parel", "Wadala", "Ghatkopar", "Navi Mumbai",
  "Panvel", "Kharghar", "Airoli", "Vashi", "Nerul",
  "Kalyan", "Dombivli", "Mira Road", "Bhayander", "Vasai",
  "Pune", "Hinjewadi", "Wakad", "Baner", "Kharadi",
  "Hadapsar", "Undri", "Pimpri-Chinchwad", "Bavdhan", "Aundh",
  "Noida", "Greater Noida", "Gurgaon", "Dwarka", "Ghaziabad",
  "Bengaluru", "Whitefield", "Electronic City", "Sarjapur", "Hebbal",
  "Hyderabad", "Gachibowli", "Kondapur", "Miyapur", "Kokapet",
  "Chennai", "OMR", "ECR", "Velachery", "Porur",
];

export const STAGES = [
  { value: "new", label: "New" },
  { value: "contacted", label: "Contacted" },
  { value: "qualified", label: "Qualified" },
  { value: "site_visit_scheduled", label: "SV Scheduled" },
  { value: "site_visit", label: "Site Visit" },
  { value: "revisit", label: "Revisit" },
  { value: "negotiation_scheduled", label: "Nego Scheduled" },
  { value: "negotiation", label: "Negotiation" },
  { value: "booked", label: "Booked" },
  { value: "re_engaged", label: "Re-Engaged" },
  { value: "lost", label: "Lost" },
];

export const PRIORITIES = [
  { value: "high", label: "High" },
  { value: "medium", label: "Medium" },
  { value: "low", label: "Low" },
];

export const TASK_TYPES = [
  { value: "follow_up", label: "Follow Up" },
  { value: "call", label: "Call" },
  { value: "callback", label: "Callback" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "email", label: "Email" },
  { value: "site_visit", label: "Site Visit" },
  { value: "meeting", label: "Meeting" },
  { value: "document", label: "Document Collection" },
  { value: "payment", label: "Payment Follow-up" },
];

export const INTERACTION_TYPES = [
  { value: "call", label: "Call" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "email", label: "Email" },
  { value: "note", label: "Note" },
  { value: "meeting", label: "Meeting" },
  { value: "site_visit", label: "Site Visit" },
];

export const VISIT_STATUSES = [
  { value: "scheduled", label: "Scheduled" },
  { value: "completed", label: "Completed" },
  { value: "cancelled", label: "Cancelled" },
  { value: "no_show", label: "No Show" },
];


export const LOST_REASONS = [
  {
    value: "budget",
    label: "Budget Mismatch",
    subReasons: ["Too expensive", "Couldn't get loan approval", "EMI too high", "Better price elsewhere"],
  },
  {
    value: "location",
    label: "Location Issue",
    subReasons: ["Too far from workplace", "Connectivity concerns", "Neighbourhood not preferred", "Infrastructure lacking"],
  },
  {
    value: "competitor",
    label: "Bought from Competitor",
    subReasons: ["Better pricing", "Better amenities", "Better brand", "Agent influence", "Better possession timeline"],
  },
  {
    value: "project",
    label: "Project Related",
    subReasons: ["Didn't like the layout", "Configuration not available", "Poor construction quality", "Delayed possession", "RERA issues"],
  },
  {
    value: "personal",
    label: "Personal Reasons",
    subReasons: ["Plans changed", "Relocation", "Family decision", "Medical/financial emergency", "Not ready to buy"],
  },
  {
    value: "unresponsive",
    label: "Unresponsive / Cold",
    subReasons: ["Not answering calls", "Blocked number", "Wrong number", "Was just enquiring"],
  },
  {
    value: "other",
    label: "Other",
    subReasons: [],
  },
];

export const INTEREST_LEVELS = [
  { value: "very_high", label: "Very High" },
  { value: "high", label: "High" },
  { value: "medium", label: "Medium" },
  { value: "low", label: "Low" },
  { value: "not_interested", label: "Not Interested" },
];

export const FACINGS = [
  { value: "east", label: "East" },
  { value: "west", label: "West" },
  { value: "north", label: "North" },
  { value: "south", label: "South" },
  { value: "north-east", label: "North-East" },
  { value: "south-east", label: "South-East" },
  { value: "north-west", label: "North-West" },
  { value: "south-west", label: "South-West" },
  { value: "garden", label: "Garden" },
  { value: "road", label: "Road" },
  { value: "park", label: "Park" },
  { value: "pool", label: "Pool" },
];
